import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Snackbar, Button } from '@mui/material';

/**
 * Nicht-blockierender Hinweis für Fahrten, die ohne Zieladresse erstellt wurden.
 *
 * Ersetzt den früheren blockierenden Bestätigungsdialog im Fahrtformular: Nach
 * dem Erstellen wird über den Navigations-State `noDestinationRideId` eine
 * Snackbar mit der Aktion "Ziel hinzufügen" angeboten. Die Komponente wird an
 * den möglichen Landeseiten eingebunden (Fahrtenliste und Dashboard), damit der
 * Hinweis unabhängig vom Rücksprungziel erscheint.
 */
const NoDestinationRideSnackbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [rideId, setRideId] = useState(null);

  useEffect(() => {
    const id = location.state?.noDestinationRideId;
    if (id) {
      setRideId(id);
      // History-State leeren, damit die Snackbar bei Reload/Zurück nicht erneut erscheint.
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  return (
    <Snackbar
      open={Boolean(rideId)}
      autoHideDuration={8000}
      onClose={() => setRideId(null)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message="Fahrt ohne Ziel erstellt"
      action={
        <Button
          color="warning"
          size="small"
          onClick={() => {
            const id = rideId;
            setRideId(null);
            navigate(`/fahrten/${id}/bearbeiten`);
          }}
        >
          Ziel hinzufügen
        </Button>
      }
    />
  );
};

export default NoDestinationRideSnackbar;
